import { DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI } from '../../default-cloud-graph-dashboard-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI } from '../../default-cloud-graph-data-table-entity-ati';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { DatabricksIcon } from './icon';
import { DatabricksSearchResultIcon } from './search-result-icon';
export const databricksConfig: ThirdPartyConfig = {
	displayName: 'Databricks',
	id: 'databricks',
	resourceType: 'databricks-connector',
	icon: get3PLogo(DatabricksIcon, 'Databricks', 'medium'),
	searchResultIcon: get3PLogo(DatabricksSearchResultIcon, 'Databricks', 'large'),
	integrationAri: 'ari:cloud:platform::integration/databricks',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Dashboard,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.DataTable,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
